/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { modelKeysSetKeyEnabled } from "../funcs/modelKeysSetKeyEnabled.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ModelProviderKey } from "../models/components/modelproviderkey.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  SetModelProviderKeyEnabledRequest,
  SetModelProviderKeyEnabledSecurity,
} from "../models/operations/setmodelproviderkeyenabled.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type SetModelProviderKeyEnabledMutationVariables = {
  request: SetModelProviderKeyEnabledRequest;
  security?: SetModelProviderKeyEnabledSecurity | undefined;
  options?: RequestOptions;
};

export type SetModelProviderKeyEnabledMutationData = ModelProviderKey;

export type SetModelProviderKeyEnabledMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * setKeyEnabled modelKeys
 *
 * @remarks
 * Enable or disable a model provider key without replacing its key material.
 */
export function useSetModelProviderKeyEnabledMutation(
  options?: MutationHookOptions<
    SetModelProviderKeyEnabledMutationData,
    SetModelProviderKeyEnabledMutationError,
    SetModelProviderKeyEnabledMutationVariables
  >,
): UseMutationResult<
  SetModelProviderKeyEnabledMutationData,
  SetModelProviderKeyEnabledMutationError,
  SetModelProviderKeyEnabledMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildSetModelProviderKeyEnabledMutation(client, options),
    ...options,
  });
}

export function mutationKeySetModelProviderKeyEnabled(): MutationKey {
  return ["@gram/client", "modelKeys", "setKeyEnabled"];
}

export function buildSetModelProviderKeyEnabledMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: SetModelProviderKeyEnabledMutationVariables,
  ) => Promise<SetModelProviderKeyEnabledMutationData>;
} {
  return {
    mutationKey: mutationKeySetModelProviderKeyEnabled(),
    mutationFn: function setModelProviderKeyEnabledMutationFn({
      request,
      security,
      options,
    }): Promise<SetModelProviderKeyEnabledMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(modelKeysSetKeyEnabled(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
